var Color = (function () {
    function detect(th, algo) {
        var imgWidth = 18;
        var imgHeight = 18;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!algo) algo = euclideanDistance;
        // Draw white Rect to avoid problems with favicon opacity
        ctx.fillStyle = 'rgb(255, 255, 255)';
        ctx.fillRect(0, 0, imgWidth, imgHeight);
        ctx.drawImage(th, 0, 0, imgWidth, imgHeight);
        try {
            var data = ctx.getImageData(0, 0, imgWidth, imgHeight);
        }
        catch (e) {
            // security error, img on diff domain
            console.log("Cross-domain error");
            return;
        }
        var rgb = algo(data);
        var hex = rgb2hex(rgb.r, rgb.g, rgb.b)
        return {hex: hex, rgb: rgb};
    }

    function euclideanDistance(data) {
        var rgb = { r: 0, g: 0, b: 0 };
        var distances = Array();
        for (var i = 0; i < data.data.length; i = i + 4) {
            // Ignore white color. Suppose we hate it.
            if (data.data[i] == 255 &&
                data.data[i + 1] == 255 &&
                data.data[i + 2] == 255) {
                continue;
            }
            var dist = 0;
            var count = 0;
            for (var j = 0; j < data.data.length; j = j + 4) {
                if (i == j) continue;
                // Ignore white color. Suppose we hate it.
                if (data.data[j] == 255 &&
                    data.data[j + 1] == 255 &&
                    data.data[j + 2] == 255)
                    continue;
                var d = { r: 0, g: 0, b: 0 };
                d.r = data.data[i] - data.data[j];
                d.g = data.data[i + 1] - data.data[j + 1];
                d.b = data.data[i + 2] - data.data[j + 2];
                dist += Math.sqrt(d.r * d.r + d.g * d.g + d.b * d.b);
                count += 1;
            }
            var pixel = new Object();
            pixel.p = i;
            pixel.d = ~~(dist / count);
            distances.push(pixel);
        }

        distances.sort(function (a, b) {
            return a.d - b.d
        });

        var topPixel = distances[0];
        if (!topPixel) return {r: 0, g: 0, b: 0};
        rgb.r = data.data[ topPixel.p ];
        rgb.g = data.data[ topPixel.p + 1 ];
        rgb.b = data.data[ topPixel.p + 2 ];
        return rgb;
    }

    function rgb2hex(rgb) {
        rgb = Array.apply(null, arguments).join().match(/\d+/g);
        rgb = ((rgb[0] << 16) + (rgb[1] << 8) + (+rgb[2])).toString(16);

        for (var i = rgb.length; i++ < 6;) rgb = '0' + rgb;

        return rgb;
    }

    function hex2rgb(hex) {
        hex = hex.replace(/ |#/g, '');
        if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
        hex = hex.match(/../g);
        return {r: parseInt(hex[0], 16), g: parseInt(hex[1], 16), b: parseInt(hex[2], 16)};
    }

    function luminance(hex, lum) {

        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;

        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }

        return rgb;
    };

    function get_brightness($hex) {
        // returns brightness value from 0 to 255
        // strip off any leading #
        $hex = $hex.replace('#', '');

        $c_r = hexdec($hex.substr(0, 2));
        $c_g = hexdec($hex.substr(2, 2));
        $c_b = hexdec($hex.substr(4, 2));

        return (($c_r * 299) + ($c_g * 587) + ($c_b * 114)) / 1000;
    };

    function is_light($hex) {
        return get_brightness($hex) > 170; //130
    }

    return {
        hex2rgb: hex2rgb,
        rgb2hex: rgb2hex,
        detect: detect,
        luminance: luminance,
        is_light: is_light
    };
})();